<template>
  <div>
    <div class="section-title">
      Paso 5. Tarjeta de credito
    </div>
    <div class="section-summary openpay">
       <div class="openpay-item">Tarjetas soportadas:<img src="/cards1.png" alt="Supported cards"></div>
    </div>
    <div class="section-content">
      <div class="section-column">
        <label class="input-label">
          Nombre del titular
          <input class="input" type="text" placeholder="Como aparece en la tarjeta" v-model="holderName" />
        </label>
        <label class="input-label">
          Número de tarjeta
          <input class="input" type="text" v-model="cardNumber" />
        </label>
        <div class="input-group2">
          <label class="input-label">
            Mes
            <input class="input" type="text" placeholder="MM" v-model="expirationMonth" />
          </label>
          <label class="input-label">
            Año
            <input class="input" type="text" placeholder="YY" v-model="expirationYear" />
          </label>
          <label class="input-label">
            CCV
            <input class="input" type="text" placeholder="3 dígitos" v-model="ccv" />
          </label>
        </div>
      </div>
      <div class="section-column">
        <div class="card">
          <div class="card-header">
            <img class="logo-img" src="/logo-white.svg" alt="Logo flagship">
            <div class="card-type">{{ cardType ? cardType.charAt(0).toUpperCase() + cardType.slice(1) : '&#8203;' }}</div>
          </div>
          <div class="card-number">{{ (cardNumber ? cardNumber : 'XXXXXXXXXXXXXXXX').replace(/\W/gi, '').replace(/(.{4})/g, '$1 ') }}</div>
          <div class="card-details">
            <div class="card-month">{{ expirationMonth ? expirationMonth : 'MM' }}</div>
            <div class="card-year">{{ expirationYear ? expirationYear : 'YY' }}</div>
            <div class="card-ccv">{{ Array(ccv.length + 1).join('*') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-error" v-if="error">
      <div class="title">{{ error.message }}</div>
      <div>{{ error.data.description }}</div>
    </div>
    <div class="section-button">
      <div class="button" @click="createToken">Siguiente</div>
    </div>
    <form id="pay" style="display: none">
      <input type="text" data-checkout="cardNumber" v-model="cardNumber">
      <input type="text" data-checkout="securityCode" v-model="ccv">
      <input type="text" data-checkout="cardExpirationMonth" v-model="expirationMonth">
      <input type="text" data-checkout="cardExpirationYear" v-model="expirationYear">
      <input type="text" data-checkout="cardholderName" v-model="holderName">
    </form>
  </div>
</template>

<script>
/* global Mercadopago:true */
import { createNamespacedHelpers } from 'vuex';

const { mapMutations } = createNamespacedHelpers('investment');

export default {
  data() {
    return {
      holderName: '',
      cardNumber: '',
      expirationMonth: '',
      expirationYear: '',
      ccv: '',
      error: null,
      cardType: null,
    };
  },
  methods: {
    onSuccess(status, response) {
      this.error = null;
      this.setCard(response.id);
      this.$emit('next');
    },
    createToken() {
      const form = document.querySelector('#pay');

      Mercadopago.createToken(form, this.onSuccess);
    },
    ...mapMutations([
      'setCard',
      'setPaymentMethodId',
    ]),
  },
  watch: {
    cardNumber(value) {
      if (value.length >= 6) {
        Mercadopago.getPaymentMethod(
          { bin: value.substring(0, 6) },
          (status, response) => {
            this.setPaymentMethodId(response[0].id);
          },
        );
      }
    },
  },
  mounted() {
    Mercadopago.setPublishableKey('APP_USR-18d7bce6-3601-4ead-b716-42483dac4fc4');
  },
};
</script>

<style lang="scss" scoped>
.input-group {
  display: flex;
  justify-content: space-between;

  .input-label {
    width: 46%;
  }
}
.input-group2 {
  display: flex;
  justify-content: space-between;

  .input-label {
    width: 30%;
  }
}
.card {
  margin-top: 20px;
  width: 100%;
  max-width: 100%;
  background-color: #171a1c;
  border-radius: 16px;
  padding: 30px;
  color: white;
  min-width: 348px;
}
.card-header {
  font-size: 15px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.card-type {
  padding-bottom: 2px;
}
.logo-img {
  width: 120px;
}
.card-number {
  width: 100%;
  font-size: 20px;
  margin-top: 60px;
  word-spacing: 5px;
  letter-spacing: 3px;
}
.card-details {
  display: flex;
  justify-content: space-between;
  margin-top: 35px;
}
.card-month {
  width: 20%;
}
.card-year {
  width: 20%;
}
.card-ccv {
  width: 60%;
  text-align: right;
}
.section-error {
  width: 100%;
  background-color: rgba(255, 0, 0, .5);
  padding: 16px 20px;
  margin: 20px 0;
  border: 1.5px solid red;
  font-size: 14px;
}
.title {
  font-weight: 500;
  margin-bottom: 6px;
}
.openpay {
  display: flex;
  justify-content: space-between;
}
.openpay-item {
  display: flex;
  align-items: center;
  img {
    margin-left: 10px;
  }
}
@media only screen and (max-width: 640px) {
  .card {
    width: 110%;
    max-width: 110%;
    min-width: 110%;
  }
  .card-number {
    font-size: 15px;
  }
}
</style>
